import { NgModule } from "@angular/core";
import {
    IconCheck, IconEdit, IconInfo, IconMessageSquare, IconX, IconAlertCircle
} from "angular-feather";

const icons = [
    IconMessageSquare,
    IconCheck,
    IconX,
    IconEdit,
    IconInfo,
    IconAlertCircle,
];

@NgModule({
    exports: icons,
})
export class IconsModule {
    //
}
